import MuiButton from "../../components/basicComponent/MuiButton";
import React, { useEffect, useState } from "react";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Header from "../../sharedScreens/Header";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import AddIcon from "@mui/icons-material/Add";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { useFormik } from "formik";
import { CouponFormSchema } from "../../validations/Schema";
import { UtilService } from "../../services/shared/UtilService";
import dayjs, { Dayjs } from "dayjs";
import {
  AppliesToOptions,
  CouponType,
  statusList,
  VoucherStatusFilterOptions,
  VoucherStatusOptions,
} from "../../constants/constant";
import { msgTypes } from "../../constants/msgTypes";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
import { useLocation } from "react-router-dom";
import {
  formatDateToDDMMMYYYY,
  getChangedFields,
} from "../../constants/helper";
import { Coupon } from "../../constants/types";
import { Pagination } from "@mui/material";
import MuiMultiSelect from "../../components/basicComponent/MuiMultiSelect";
import MuiUploader from "../../components/basicComponent/MuiUploader";
import NoDataFlightCard from "../../components/composite/NoDataFlightCard";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import ApiUrl from "../../services/shared/ApiUrl";
import { useGlobalState } from "../../services/context/AuthContext";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const VoucherCode = () => {
  const [value, setValue] = React.useState(0);
  const [corporateOptions, setCorporateOptions] = useState([]);
  const [couponList, setCouponList] = useState<Coupon[]>([]);
  const { showSuccess, showError, showInfo, showConfirm } = useSweetAlert();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const location = useLocation();
  const [corporateId, setCorporateId] = useState<string[] | null>(null);
  const [selectedAppliesTo, setSelectedAppliesTo] = useState<string>("");
  const [selectedCorporate, setSelectedCorporate] = useState({
    label: "",
    value: "",
  });
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const initialValues: Coupon = {
    code: "",
    description: "",
    couponType: "",
    value: "",
    appliesTo: "",
    eligibleCorporatesData: [],
    maxUsesPerUser: "",
    maxUses: "",
    minPurchase: "",
    validFrom: null,
    validUntil: null,
    status: "",
    couponImage: "",
    maxDiscountAmount: 0,
  };

  const { userInfo } = useGlobalState();

  const [originalData, setOriginalData] = useState<Coupon | null>(null);
  console.log("originalData", originalData);
  const formik = useFormik({
    initialValues: originalData || initialValues,
    validationSchema: CouponFormSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (!!originalData) {
        editVoucherCode();
      } else {
        try {
          const payload = {
            code: values.code,
            description: values.description,
            coupon_type: values.couponType,
            value: values.value ? parseFloat(values.value.toString()) : 0,
            applies_to: values.appliesTo,
            max_uses_per_user: values.maxUsesPerUser,
            max_uses: values.maxUses,
            min_purchase: values.minPurchase,
            valid_from: values.validFrom,
            valid_until: values.validUntil,
            status: values.status,
            max_discount_amount: values.maxDiscountAmount,
            couponImage: values.couponImage,
            ...(corporateId && { eligible_corporates: corporateId }), // ← only adds if corporateId is truthy
          };

          const response = await UtilService.createCoupon(payload);

          if (response?.statusMsg === msgTypes.SUCCESS.msg) {
            showSuccess("Success!", "Coupon has been created successfully.", {
              timer: 3000,
              timerProgressBar: true,
            }).then(() => {
              setValue(1);
              const payload = {
                status: "active",
              };
              fetchCoupons(payload);
            });
            formik.resetForm();
          }
          // alert("Coupon created successfully!");
        } catch (error) {
          console.log(error);
        }
      }
    },
  });

  // API call to fetch corporates
  const getEligibleCorporates = async () => {
    const response = await UtilService.getBusinessName();
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const data = response?.data?.map(
        (item: { id: string; businessName: string }) => ({
          id: item.id,
          label: item.businessName,
          value: item.businessName,
        })
      );
      setCorporateOptions(data);
    }
  };

  useEffect(() => {
    getEligibleCorporates();
  }, []);

  // Api Call Fetch Coupons
  const fetchCoupons = async (filters?: {}) => {
    try {
      const res = await UtilService.getCouponList(filters);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setCouponList(res.data);
      }
      return res;
    } catch (err) {
      console.error("Error fetching coupons", err);
    }
  };

  const autoInactiveCoupons = async () => {
    const now = new Date();
    couponList?.map((coupon) => {
      const validUntil = new Date(coupon.validUntil || "");
      if (validUntil < now && coupon.status !== "disabled") {
        const payload = {
          status: "disabled",
        };
        setInActiveCoupon(payload, coupon.id || "");
      }
    });
  };

  useEffect(() => {
    const payload = {
      status: "active",
    };
    fetchCoupons(payload); // Initial fetch without filters
    autoInactiveCoupons();
  }, []);

  const editVoucherCode = async (): Promise<void> => {
    const changedFields = getChangedFields(originalData ?? {}, formik.values);

    if (Object.keys(changedFields).length === 0) {
      showInfo("No changes", "No fields were modified.");
      return;
    }

    const payload = {
      ...(changedFields.code && { code: changedFields.code }),
      ...(changedFields.description && {
        description: changedFields.description,
      }),
      ...(changedFields.couponType && {
        coupon_type: changedFields.couponType,
      }),
      ...(changedFields.value && { value: changedFields.value }),
      ...(changedFields.appliesTo && { applies_to: changedFields.appliesTo }),
      ...(changedFields.eligibleCorporatesData && {
        eligible_corporates: corporateId,
      }),
      ...(changedFields.maxUsesPerUser && {
        max_uses_per_user: changedFields.maxUsesPerUser,
      }),
      ...(changedFields.maxUses && {
        max_uses: changedFields.maxUses,
      }),
      ...(changedFields.minPurchase && {
        min_purchase: changedFields.minPurchase,
      }),
      ...(changedFields.validFrom && {
        valid_from: new Date(changedFields.validFrom).toISOString(),
      }),
      ...(changedFields.validUntil && {
        valid_until: new Date(changedFields.validUntil).toISOString(),
      }),
      ...(changedFields.status && { status: changedFields.status }),
    };
    const id = originalData?.id || "";
    try {
      const response = await UtilService.editCoupon(payload, id);
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess("Success!", "Coupon has been updated successfully.", {
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
          setValue(1);
          fetchCoupons();
          setOriginalData(null); // Reset original data after successful update
          formik.resetForm();
        });
      }
    } catch (error) {
      showError("Error!", "Failed to update coupon.");
      console.error(error);
    }
  };
  const paginatedCoupons = couponList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const deleteCoupon = async (id: string) => {
    try {
      const response = await UtilService.deleteCoupon(id);
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess("Success!", "Coupon has been deleted successfully.", {
          timer: 3000,
          timerProgressBar: true,
        });
        fetchCoupons(); // Refresh the coupon list after deletion
      }
    } catch (error) {
      showError("Error!", "Failed to delete coupon.");
      console.error(error);
    }
  };

  const handleToggleBtn = (item: Coupon) => {
    if (item.status === "active") {
      showConfirm(
        "",
        `Are you sure you want to deactivate ${item.code} ? `
      ).then((result) => {
        if (result?.isConfirmed) {
          const payload = {
            status: "disabled",
          };
          setInActiveCoupon(payload, item?.id ?? "");
        }
      });
    } else {
      showConfirm("", `Are you sure you want to activate ${item.code} ? `).then(
        (result) => {
          if (result?.isConfirmed) {
            const payload = {
              status: "active",
            };
            setInActiveCoupon(payload, item?.id ?? "");
          }
        }
      );
    }
  };

  const setInActiveCoupon = async (payload: {}, id: string) => {
    const response = await UtilService.editCoupon(payload, id);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const payload = {
        status: "active",
      };
      fetchCoupons(payload);
    }
  };

  const handleFileUpload = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("couponImage", "File upload failed.");
    } else {
      formik.setFieldValue("couponImage", uploadedFileUrl);
      formik.setFieldError("couponImage", "");
    }
  };

  const handleClear = () => {
    if (
      !selectedAppliesTo &&
      !selectedCorporate?.label &&
      !selectedCorporate?.value &&
      !selectedStatus
    ) {
      showInfo("Nothing to Clear", "All filters are already empty.");
      return;
    }
    setSelectedAppliesTo("");
    setSelectedCorporate({
      label: "",
      value: "",
    });
    setSelectedStatus("");
    const payload = {
      status: "active",
    };
    fetchCoupons(payload);
  };

  const handleFilterSubmit = () => {
    if (
      !selectedAppliesTo &&
      !selectedCorporate?.label &&
      !selectedCorporate?.value &&
      !selectedStatus
    ) {
      showInfo(
        "Validation",
        "Please select at least one filter: Applied To, Corporate or Status."
      );
      return;
    }
    fetchCoupons({
      applies_to: selectedAppliesTo,
      eligible_corporates: selectedCorporate?.value,
      status: selectedStatus,
    });
  };

  const isAnyEditable = paginatedCoupons?.some(
    (item) => item.status !== "disabled" && item.status !== "expired"
  );

  useEffect(() => {
    const savedTab = sessionStorage.getItem("voucherTab");
    if (savedTab) {
      setValue(Number(savedTab));
    }

    return () => {
      sessionStorage.removeItem("voucherTab");
    };
  }, []);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    sessionStorage.setItem("voucherTab", newValue.toString());
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">Coupon Creation</h3>
            </div>
            <div className="card">
              <div className="row">
                <div className="col-md-12 ancillary-services-card">
                  <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          icon={<AddIcon />}
                          label={originalData ? "Update" : "Create"}
                          {...a11yProps(0)}
                          iconPosition="start"
                        />
                        <Tab
                          icon={<RemoveRedEyeIcon />}
                          label="View"
                          {...a11yProps(1)}
                          iconPosition="start"
                        />
                      </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                      <div className="row mt-2">
                        <div className="col-12 col-sm-6 col-xl-4 mb-3 mb-md-0">
                          <MuiInput
                            label="Code"
                            placeholder="Code"
                            isRequired={true}
                            name="code"
                            value={formik.values.code}
                            onChange={(e: any) =>
                              formik.setFieldValue("code", e)
                            }
                            onBlur={async () => {
                              formik.handleBlur("code"); // Mark field as touched
                              formik.setFieldTouched("code", true);
                              const code = formik.values.code;

                              if (code) {
                                try {
                                  const response = await fetchCoupons(); // Call your API here

                                  if (
                                    response?.data?.some((i: any) =>
                                      i?.code?.includes(code)
                                    )
                                  ) {
                                    // formik.setFieldError(
                                    //   "code",
                                    //   "This code already exists"
                                    // );
                                    showInfo("", "This code already exists");
                                  }
                                } catch (err) {
                                  console.error("Error checking code:", err);
                                  formik.setFieldError(
                                    "code",
                                    "Error validating code"
                                  );
                                }
                              }
                            }}
                            error={formik.touched.code && !!formik.errors.code}
                            helperText={
                              formik.touched.code && formik.errors.code
                            }
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mb-3 mb-md-0">
                          <MuiInput
                            label="Code Description"
                            placeholder="Code Description"
                            isRequired={true}
                            name="description"
                            value={formik.values.description}
                            onChange={(e: any) =>
                              formik.setFieldValue("description", e)
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.description &&
                              !!formik.errors.description
                            }
                            helperText={
                              formik.touched.description &&
                              formik.errors.description
                            }
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mb-3 mb-md-0">
                          <MuiDropDown
                            label="Coupon Type"
                            placeholder="Coupon Type"
                            value={formik.values.couponType}
                            onChange={(value, id) =>
                              formik.setFieldValue("couponType", value)
                            }
                            options={CouponType}
                            isInvalid={
                              formik.touched.couponType &&
                              Boolean(formik.errors.couponType)
                            }
                            errorText={
                              formik.touched.couponType &&
                              formik.errors.couponType
                                ? formik.errors.couponType
                                : ""
                            }
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-xl-4">
                          <MuiInput
                            label={`Value ${
                              formik.values.couponType === "percent" ? "%" : ""
                            }`}
                            placeholder={`Value ${
                              formik.values.couponType === "percentage"
                                ? "%"
                                : ""
                            }`}
                            name="value"
                            value={formik.values.value}
                            onChange={(e: any) =>
                              formik.setFieldValue("value", e)
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.value && !!formik.errors.value
                            }
                            helperText={
                              formik.touched.value && formik.errors.value
                            }
                            isRequired={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4 ">
                          <MuiDropDown
                            label="Applies to"
                            placeholder="Applies to"
                            options={AppliesToOptions}
                            value={formik.values.appliesTo}
                            onChange={(value, id) =>
                              formik.setFieldValue("appliesTo", value)
                            }
                            isInvalid={
                              formik.touched.appliesTo &&
                              Boolean(formik.errors.appliesTo)
                            }
                            errorText={
                              formik.touched.appliesTo &&
                              formik.errors.appliesTo
                                ? formik.errors.appliesTo
                                : ""
                            }
                            isRequired={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiMultiSelect
                            options={corporateOptions}
                            onChange={(value, id) => {
                              formik.setFieldValue(
                                "eligibleCorporatesData",
                                value
                              );
                              setCorporateId(id);
                            }}
                            value={formik.values.eligibleCorporatesData}
                            placeholder="Eligible Corporates"
                            // enableSelectAll={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiInput
                            label="Max uses per user"
                            placeholder="Max uses per user"
                            value={
                              formik.values.maxUsesPerUser?.toString() ?? ""
                            }
                            onChange={(e: any) =>
                              formik.setFieldValue("maxUsesPerUser", e)
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.maxUsesPerUser &&
                              !!formik.errors.maxUsesPerUser
                            }
                            helperText={
                              formik.touched.maxUsesPerUser &&
                              formik.errors.maxUsesPerUser
                            }
                            isRequired={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiInput
                            label="Max uses"
                            placeholder="Max uses"
                            name="maxUses"
                            value={formik.values.maxUses}
                            onChange={(e: any) =>
                              formik.setFieldValue("maxUses", e)
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.maxUses && !!formik.errors.maxUses
                            }
                            helperText={
                              formik.touched.maxUses && formik.errors.maxUses
                            }
                            isRequired={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiInput
                            label="Min purchase"
                            placeholder="Min purchase"
                            name="minPurchase"
                            value={formik.values.minPurchase}
                            onChange={(e: any) =>
                              formik.setFieldValue("minPurchase", e)
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.minPurchase &&
                              !!formik.errors.minPurchase
                            }
                            isRequired={true}
                            helperText={
                              formik.touched.minPurchase &&
                              formik.errors.minPurchase
                            }
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          {/* <MuiDatePicker
                            label="Valid From"
                            value={formik.values.validFrom || null}
                            onChange={(date) =>
                              formik.setFieldValue("validFrom", date)
                            }
                          /> */}

                          <MuiDatePicker
                            label="Valid From"
                            value={
                              formik.values.validFrom &&
                              dayjs(formik.values.validFrom).isValid()
                                ? dayjs(formik.values.validFrom)
                                : null
                            }
                            onChange={(val: string) => {
                              formik.setFieldValue("validFrom", val);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("validFrom", true)
                            }
                            isError={Boolean(
                              formik.touched.validFrom &&
                                formik.errors.validFrom
                            )}
                            errorText={
                              formik.touched.validFrom &&
                              formik.errors.validFrom
                                ? formik.errors.validFrom
                                : ""
                            }
                            isRequired={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiDatePicker
                            label="Valid Until"
                            value={
                              formik.values.validUntil &&
                              dayjs(formik.values.validUntil).isValid()
                                ? dayjs(formik.values.validUntil)
                                : null
                            }
                            onChange={(date: string) => {
                              formik.setFieldValue("validUntil", date);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("validUntil", true)
                            }
                            isError={Boolean(
                              formik.touched.validUntil &&
                                formik.errors.validUntil
                            )}
                            errorText={
                              formik.touched.validUntil &&
                              formik.errors.validUntil
                                ? formik.errors.validUntil
                                : ""
                            }
                            isRequired={true}
                          />
                        </div>

                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiUploader
                            label={"Coupon Image"}
                            name={"Coupon Image"}
                            values={formik.values.couponImage}
                            errors={
                              formik.touched.couponImage &&
                              formik.errors.couponImage
                                ? formik.errors.couponImage?.toString()
                                : ""
                            }
                            onFileUpload={handleFileUpload}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-xl-4 mt-4">
                          <MuiDropDown
                            label="Status"
                            placeholder="Status"
                            options={VoucherStatusOptions}
                            value={formik.values.status}
                            onChange={(value) =>
                              formik.setFieldValue("status", value)
                            }
                            isRequired={true}
                            isInvalid={
                              formik.touched.status &&
                              Boolean(formik.errors.status)
                            }
                            errorText={
                              formik.touched.status ? formik.errors.status : ""
                            }
                          />
                        </div>

                        <div className="row">
                          <div
                            className={`${
                              !!originalData ? "col-md-8" : "col-12"
                            }`}
                          >
                            <div
                              className={`user-button mt-3 ${
                                !!originalData
                                  ? "justify-content-start"
                                  : "justify-content-center"
                              }`}
                            >
                              <MuiButton
                                className="clear-btn"
                                label={!!originalData ? "Create New" : "Clear"}
                                type="button"
                                onClick={
                                  !!originalData
                                    ? () => {
                                        setOriginalData(null);
                                        formik.resetForm();
                                      }
                                    : () => formik.resetForm()
                                }
                              />
                              <MuiButton
                                className="main-btn get-btn"
                                variant="contained"
                                size="large"
                                type="submit"
                                label={!!originalData ? "Update" : "Create"}
                                onClick={() => formik.handleSubmit()}
                              />
                            </div>
                          </div>
                          {!!originalData && (
                            <div className="col-md-4 mt-3 d-flex justify-content-end align-items-center">
                              <button
                                onClick={() => {
                                  setValue(1);
                                  sessionStorage.setItem("voucherTab", "1");
                                }}
                                type="button"
                                className="btn btn-danger d-flex align-items-center gap-2"
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                      <div className="row mt-4">
                        <div className="col-md-4 mb-3 mb-md-0">
                          <MuiDropDown
                            label="Applies to"
                            placeholder="Applies to"
                            options={AppliesToOptions}
                            value={selectedAppliesTo}
                            onChange={(value, id) =>
                              setSelectedAppliesTo(value)
                            }
                          />
                        </div>
                        <div className="col-md-4 mb-3 mb-md-0">
                          <MuiDropDown
                            label="Select Corporates"
                            placeholder="Eligible Corporates"
                            options={corporateOptions}
                            value={selectedCorporate.label}
                            onChange={(value, id) =>
                              setSelectedCorporate({
                                label: value,
                                value: id,
                              })
                            }
                          />
                        </div>
                        <div className="col-md-4 ">
                          <MuiDropDown
                            label="Select Status"
                            placeholder="Status"
                            options={VoucherStatusFilterOptions}
                            value={selectedStatus}
                            onChange={(value) => setSelectedStatus(value)}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <div className="user-button w-full">
                            <MuiButton
                              className="clear-btn "
                              label="Clear"
                              type="submit"
                              onClick={() => {
                                handleClear();
                              }}
                            />
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Get"}
                              onClick={() => handleFilterSubmit()}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-4">
                        <div className="card card-grid min-w-full">
                          <div className="card-body">
                            <div
                              data-datatable="true"
                              data-datatable-page-size={20}
                              className="datatable-initialized"
                            >
                              <div className="table-responsive position-relative scrollable-x-auto">
                                <table
                                  className="table table-border"
                                  data-datatable-table="true"
                                >
                                  <thead>
                                    <tr>
                                      {isAnyEditable && (
                                        <th
                                          className="position-sticky start-0  z-3"
                                          style={{ minWidth: "50px" }}
                                        >
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Edit
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                      )}
                                      <th
                                        className="position-sticky   z-3"
                                        style={{
                                          left: isAnyEditable ? "72px" : "0px",
                                        }}
                                      >
                                        <span className="sort">
                                          <span
                                            style={{ minWidth: "50px" }}
                                            className="sort-label text-gray-700 font-normal"
                                          >
                                            Status
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Eligible Corporates
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            code
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Code Description
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>

                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Coupon Type
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            value
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Applies To
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Max Uses Per Corporate
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Max Uses
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Min Purchase
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Coupon Image
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Used Count
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Valid From
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Valid Until
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Status
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Max Discount Amount
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Created Date
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                      <th>
                                        <span className="sort">
                                          <span className="sort-label text-gray-700 font-normal">
                                            Updated Date
                                          </span>
                                          <span className="sort-icon"></span>
                                        </span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {paginatedCoupons?.length === 0 ? (
                                      <tr>
                                        <td
                                          colSpan={10}
                                          className="text-center text-gray-500"
                                        >
                                          <div className="d-flex flex-column align-items-center justify-content-start py-4">
                                            <div
                                              className="d-flex align-items-center justify-content-center bg-light rounded-circle mb-3"
                                              style={{
                                                width: "80px",
                                                height: "80px",
                                              }}
                                            >
                                              <img
                                                src="media/images/remove-folder.png"
                                                alt="remove-folder"
                                                style={{
                                                  maxWidth: "40px",
                                                  maxHeight: "40px",
                                                }}
                                              />
                                            </div>
                                            <h5 className="text-muted mb-0 fw-bold fs-5">
                                              No Data Found
                                            </h5>
                                          </div>
                                        </td>
                                      </tr>
                                    ) : (
                                      paginatedCoupons?.map((item, index) => (
                                        <tr key={index}>
                                          {isAnyEditable && (
                                            <td className="position-sticky start-0 z-2">
                                              <span
                                                className="text-success"
                                                onClick={() => {
                                                  setValue(0);
                                                  sessionStorage.setItem(
                                                    "voucherTab",
                                                    "0"
                                                  );
                                                  setOriginalData({
                                                    ...item,
                                                    validUntil:
                                                      formatDateToDDMMMYYYY(
                                                        item.validUntil ?? ""
                                                      ),
                                                    eligibleCorporatesData:
                                                      item.eligibleCorporatesData?.map(
                                                        (i: any) =>
                                                          i?.businessName
                                                      ),
                                                  });
                                                }}
                                              >
                                                <span className="badge badge-sm badge-warning badge-outline cursor-pointer">
                                                  <i className="fa-solid fa-pen-to-square pe-0"></i>
                                                </span>
                                              </span>
                                            </td>
                                          )}

                                          <td
                                            className="position-sticky   z-2"
                                            style={{
                                              left: isAnyEditable
                                                ? "72px"
                                                : "0px",
                                            }}
                                          >
                                            <div className="sort">
                                              <Switch
                                                checked={
                                                  item.status === "active"
                                                }
                                                onClick={() =>
                                                  handleToggleBtn(item)
                                                }
                                                size="small"
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.eligibleCorporatesData
                                                ?.map(
                                                  (corp: any) =>
                                                    corp.businessName
                                                )
                                                .join(", ")}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.code}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.description}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.couponType}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.couponType === "percent"
                                                ? `${item.value}%`
                                                : `${userInfo?.currencyCode}${item.value}`}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.appliesTo}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.maxUsesPerUser}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.maxUses}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.minPurchase}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.couponImage ? (
                                                <img
                                                  src={
                                                    ApiUrl.fileBaseUrl +
                                                    item.couponImage
                                                  }
                                                  alt="coupon"
                                                  width="50"
                                                />
                                              ) : (
                                                "-"
                                              )}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.usedCount || 0}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {!!item.validFrom
                                                ? formatDateToDDMMMYYYY(
                                                    item.validFrom
                                                  )
                                                : "-"}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {!!item.validUntil
                                                ? formatDateToDDMMMYYYY(
                                                    item.validUntil
                                                  )
                                                : "-"}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort text-capitalize">
                                              {item.status}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {item.maxDiscountAmount}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {!!item.createdAt
                                                ? formatDateToDDMMMYYYY(
                                                    item.createdAt
                                                  )
                                                : "-"}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sort">
                                              {!!item.updatedAt
                                                ? formatDateToDDMMMYYYY(
                                                    item.updatedAt
                                                  )
                                                : "-"}
                                            </div>
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-end my-2">
                                <Pagination
                                  count={Math.ceil(
                                    couponList.length / pageSize
                                  )}
                                  page={currentPage}
                                  onChange={(e: any, page) =>
                                    setCurrentPage(page)
                                  }
                                  color="primary"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CustomTabPanel>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default VoucherCode;
